module.exports = __webpack_public_path__ + "static/media/rs.0b9d64b2.svg";